module.exports = require('./helpers/bundle-url').getBundleURL('jWbtw') + "BTCKLogo.9770427e.png";